"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var imgUrlPreparer = function (url, urlPrefix) {
    if (urlPrefix === void 0) { urlPrefix = ''; }
    if (url.indexOf('{STORYBOOK}') !== -1) {
        var currentProtocol = window.location.protocol;
        var currentHost = window.location.host;
        var currentPath = window.location.pathname;
        return url.replace('{STORYBOOK}', currentProtocol + "//" + currentHost + "//" + currentPath.replace(/[^/]*$/, ''));
    }
    return url.indexOf('http') !== -1 ? url : "" + urlPrefix + url;
};
exports.default = imgUrlPreparer;
//# sourceMappingURL=imgPreparer.js.map